import { render, staticRenderFns } from "./ForumDetail.vue?vue&type=template&id=6dda81e2&"
import script from "./ForumDetail.vue?vue&type=script&lang=js&"
export * from "./ForumDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports